import { CoinIDType } from '@starsoft/common/enums/coinId';
import { Nullable } from '../../../interfaces';
import { UserPaymentDetailsNamespace } from '../../../namespaces';
import { useCoallescedCoinId } from '../../coin/useCoallescedCoinId';

/**
 * Custom hook to get the user payment type ID by coin ID.
 * This hook uses the coalesced coin ID to fetch the corresponding user payment type ID.
 *
 * @returns {Nullable<string>} The user payment type ID if available, otherwise null.
 *
 * @example
 * // Usage example:
 * const userPaymentTypeId = useUserPaymentTypeIdByCoinId();
 */
export function useUserPaymentTypeIdByCoinId(): Nullable<string> {
  // Get the coalesced coin ID using the custom hook
  const { coinId } = useCoallescedCoinId();

  // Fetch the user payment type ID by coin ID from the namespace
  const userPaymentTypeId: Nullable<string> =
    UserPaymentDetailsNamespace.getUserPaymentDetailsTypeIdByCoinId(
      coinId as CoinIDType,
    );

  // Return the user payment type ID
  return userPaymentTypeId;
}
